import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";
import { categoryList } from "@/mocks/comics";

function categoryName(key: string) {
  return categoryList.find((c) => c.key === key)?.name ?? key;
}

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} 漫画封面与简介`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-full bg-secondary-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {comic.rating}
        </span>
      </div>
      <div className="flex flex-col gap-1 p-3 md:p-4">
        <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600 md:text-sm">
          {categoryName(comic.category)} · {comic.author}
        </p>
        <p className="flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-time-line" />
          {comic.lastUpdate}
        </p>
      </div>
    </Link>
  );
}